<script setup lang="ts">
import { NuxtLinkLocale } from '#components';
import type { BrandInterface } from '~~/server/types/Brands';

const props = defineProps<{
  brand: BrandInterface;
  showName: boolean;
  linkToBrand: boolean;
}>();
const image = computed(() => props.brand.icon || props.brand.thumb || props.brand.photo);
</script>

<template>
  <component
    :is="linkToBrand ? NuxtLinkLocale : 'div'"
    :to="linkToBrand ? brand.url : undefined"
    :aria-label="linkToBrand ? brand.name : undefined"
    class="brand-card"
  >
    <img v-if="image" :src="image" :alt="showName ? '' : brand.name" width="100" height="80" loading="lazy" decoding="async">
    <span v-if="showName" class="brand-card__name">{{ brand.name }}</span>
  </component>
</template>
